export const FINAL_VERIFICATION_ACTIONS = Object.freeze({
  START_CONTROL: "start-control",
  ACCEPT_USER_AGREEMENT: "accept-ua",
  RESET_CONTROL: "reset-control",
  COMPLETE_CONTROL: "complete-control",
  TECHNICAL_APPROVAL: "technical-approval",
  TECHNICAL_AND_METERING_APPROVAL: "technical-approval-and-metering-approval",
  CONTRACT_APPROVAL: "contract-approval",
  NETWORK_METERING_AVAILABLE: "network-operator-metering-data-available",
  NETWORK_METERING_APPROVAL: "network-operator-metering-approval",
  ADD_COMMENTS: "add-comments",
});
